import {
  Link,
  Clock,
  FolderOpen,
  Building2,
  Users,
  Globe,
  Server,
  FileText,
  Database,
  CreditCard,
  Megaphone,
  Network,
  Chrome,
  SearchIcon,
  Cloud,
  NetworkIcon,
  Mail,
  FileCheck,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { SearchInput } from "@/components/ui/search-input";
import { Button } from "@/components/ui/button";

const navigationItems = [
  { label: "URLs", icon: Link, route: "/urls" },
  { label: "URL Review Queue", icon: Clock, route: "/url-review-queue" },
  { label: "Review Notices", icon: FileCheck, route: "/review-notices" },
  { label: "Cases", icon: FolderOpen, route: "/cases" },
  { label: "Agencies", icon: Building2, route: "/agencies" },
  { label: "User Management", icon: Users, route: "/users" },
  { label: "Templates", icon: Mail, route: "/templates" },
  { label: "Domains", icon: Globe, route: "/domains" },
  { label: "Hosting Providers", icon: Server, route: "/hosting-providers" },
  { label: "Domain Registrars", icon: FileText, route: "/domain-registrars" },
  { label: "Registries", icon: Database, route: "/registries" },
  { label: "Payment Processors", icon: CreditCard, route: "/payment-processors" },
  { label: "Ad Tech", icon: Megaphone, route: "/ad-tech" },
  { label: "ISPs", icon: Network, route: "/isps" },
  { label: "Browsers", icon: Chrome, route: "/browsers" },
  { label: "Search Engines", icon: SearchIcon, route: "/search-engines" },
  { label: "CDNs", icon: Cloud, route: "/cdns" },
  { label: "DNS", icon: NetworkIcon, route: "/dns" },
];

export function AppSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <Sidebar>
      <SidebarContent className="p-0 gap-0">
        {/* Search field */}
        <div className="flex h-14 px-6 items-center justify-center">
          <SearchInput placeholder="Search Navigation..." />
        </div>
        <Separator />

        {/* Navigation items */}
        <SidebarGroup className="p-0">
          <SidebarGroupContent>
            <SidebarMenu className="pt-3">
              {navigationItems.map((item) => {
                // Check if current route matches exactly or starts with the item route
                const isActive = location.pathname === item.route || 
                  (item.route !== "/" && location.pathname.startsWith(item.route));
                const Icon = item.icon;

                return (
                  <SidebarMenuItem key={item.label} className="px-6 py-0">
                    <Button
                      variant="ghost"
                      onClick={() => handleNavigation(item.route)}
                      className={`
                        w-full h-9 flex items-center rounded-md justify-start
                        ${isActive ? 'bg-muted' : ''}
                      `}
                    >
                      {/* Icon column - same padding as search icon (pl-5 pr-3) */}
                      <div className="flex items-center pl-5 pr-3 shrink-0">
                        <Icon className="h-4 w-4 text-foreground" />
                      </div>
                      {/* Text column - aligns with search text */}
                      <span className="text-foreground text-sm">{item.label}</span>
                    </Button>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}

